import { useEffect, useState } from 'react';
import styles from './styles';

interface SheetProps {
  open: boolean;
  onClose: () => void;
  direction: 'right' | 'left' | 'bottom' | 'top';
  children: React.ReactNode;
}

const Sheet = ({ open, onClose, direction, children }: SheetProps) => {
  const [isMounted, setIsMounted] = useState(open);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (open) {
      setIsMounted(true);
      document.body.style.overflow = 'hidden';

      timer = setTimeout(() => setIsVisible(true), 500);
    } else {
      setIsVisible(false);
      document.body.style.overflow = '';

      timer = setTimeout(() => setIsMounted(false), 500);
    }

    return () => clearTimeout(timer);
  }, [open]);
  if (!isMounted) return null;

  return (
    <div css={styles.wrapper}>
      <div
        css={[styles.overlay, isVisible && styles.overlayVisible]}
        onClick={onClose}
      />
      <div css={[styles.sheet, styles[direction], isVisible && styles.visible]}>
        {children}
      </div>
    </div>
  );
};

export default Sheet;
